import { Fragment, useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./css/articulo.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import parse from "html-react-parser";
import { Server } from "../../constants";

function InfoArticulo({ url }) {
  const [articulo, setArticulo] = useState({
    fecha: "",
    titulo: "",
    idImagen: "",
    imagen: null,
    contenido: null,
  });

  const url_send = useMemo(() => url.replace(/\//g, "..."), [url]);

  useEffect(() => {
    const fetchArticulo = async () => {
      const { data } = await axios.get(`${Server}/api/conseguir_articulo/${url_send}`);
      const fechaFormateada = new Intl.DateTimeFormat('es-EC', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(data[0].NOT_FECHA));

      setArticulo({
        fecha: fechaFormateada,
        titulo: data[0].NOT_TITULO,
        idImagen: data[0].NOT_CODIGO,
        imagen: data[0].NOT_URL_IMAGEN,
        contenido: parse(data[0].NOT_DESCRIPCION),
      });
    };
    fetchArticulo();
  }, [url_send]);

  useEffect(() => {
    if (articulo.imagen) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = articulo.imagen;
      document.head.appendChild(link);
    }
  }, [articulo.imagen]);

  const { fecha, titulo, idImagen, imagen, contenido } = articulo;

  return (
    <Fragment>
      <link rel="preload" as="image" href={imagen} />
      <div className="bg-sand" style={{ height: "270px", overflow: "hidden" }}>
        <Container>
          <Row className="py-4 py-md-5">
            <Col md={12}>
              <h1 className="titulo-articulo">{titulo}</h1>
              <h2 className="fecha-artitulo text-left">{fecha}</h2>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row>
          <Col md={12} className="mt-3 mt-md-5">
            <Image
              className="slider-img-desktop"
              src={imagen}
              alt={titulo}
              id={idImagen}
              title={titulo}
              width="1150"
              height="600"
              fluid
            />
            <Image
              className="slider-img-mobile"
              src={imagen}
              alt={titulo}
              id={idImagen}
              title={titulo}
              fluid
              loading="lazy"
            />
          </Col>
          <Col md={12} className="my-3 mt-md-4 mb-md-5">
            {contenido}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default InfoArticulo;
